import { ScreenSize, useWindowSize } from "./useWindowSize";

const minSize = {
  width: 1950,
  height: 940,
};

export const useGraphicScale = () => {
  const windowSize = useWindowSize();
  const scales: ScreenSize = {
    width: Math.min(1, windowSize.width / minSize.width),
    height: Math.min(1, windowSize.height / minSize.height),
  };
  const scale = Math.min(scales.width, scales.height);
  return { scale, scaleWidth: scales.width, scaleHeight: scales.height };
};
